import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Row } from 'modules/trainings/components/MyTrainings/NextSessionRow/Row'
import { useMyTrainingDatatable } from 'modules/trainings/hooks/MyTrainings/useMyTrainingDatatable'
import { useTrainingsSessions } from 'modules/trainings/hooks/Sessions/useTrainingsSessions'

interface Props {
  sessionUrl: (sessionId: string) => string
  accessId: number
}

export const NextSessionRow = ({ sessionUrl, accessId }: Props) => {
  const { getTrainings } = useMyTrainingDatatable()
  const trainings = getTrainings()
  const trainingIds = trainings?.map((training) => training.id) || []
  const { loading, sessions } = useTrainingsSessions({ next: true, trainingIds, accessId })

  const nextSession = sessions?.[0]
  if (loading) {
    return null
  }

  return (
    <>
      {nextSession && (
        <Box gap="s32">
          <Text.Header2>
            {i18n.t('trainings.my_training.all_courses_table.next_session')}
          </Text.Header2>
          <Row
            firstSession={nextSession}
            trainingName={nextSession.name}
            sessionUrl={sessionUrl(String(nextSession.id))}
          />
        </Box>
      )}
    </>
  )
}
